import React, {useState} from  "react";
import "./Skills.scss";
import skills_1 from "../assets/skills_1.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import figma from "../assets/figma.png";
import bootstrap from "../assets/bootstrap.png";
import vue from "../assets/vuejs.png";
import tailwind from "../assets/tailwindcss.png";
import node from "../assets/nodejs.png";
import cpp from "../assets/cpp.png";
import python from "../assets/python.png";
import git from "../assets/git.png";
import github from "../assets/github.png";
import skills_bg from "../assets/skills_bg.png";
// import skills_bg_hover from "../assets/skills_bg_hover.png";
import SkillsDisplay from "./SkillsDisplay";

const Skills = () => {
  const [skills_Bg, set_Skills_Bg] = useState(skills_bg)
  const skills_arr = [
    {
      skills_icon: skills_1,
      skills_text: "HTML",
    },
    {
      skills_icon: css,
      skills_text: "CSS",
    },
    {
      skills_icon: javascript,
      skills_text: "Javascript",
    },
    {
      skills_icon: react,
      skills_text: "React",
    },
    {
      skills_icon: redux,
      skills_text: "redux",
    },
    {
      skills_icon: vue,
      skills_text: "Vue Js",
    },
    {
      skills_icon: bootstrap, 
      skills_text: "Bootstrap",
    },
    {
      skills_icon: tailwind,
      skills_text: "Tailwind CSS",
    },
    {
      skills_icon: node,
      skills_text: "Node JS",
    },
    {
      skills_icon: cpp,
      skills_text: "C++",
    },
    {
      skills_icon: python,
      skills_text: "Python",
    },
    {
      skills_icon: git,
      skills_text: "Git",
    },
    {
      skills_icon: github,
      skills_text: "Github",
    },
    
    
  ];


  return (
    <div className="skills_display_cont d-flex justify-content-center align-items-center">
      {skills_arr.map((item, idx) => (
        <SkillsDisplay  key={idx} items={item} index={idx}  />
      ))}
    </div>
  );
};

export default Skills;
